import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default function usePublicationsList() {
    const isPublicationsFormSidebarActive = ref(false);
    const catsData = ref([]);
    const toast = useToast();
    const refPublicationsListTable = ref(null);
    const tableColumns = [
      { key: 'cover_image', label: 'Cover Image', sortable: false, tdClass:'width-200 p-1' },
      
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false },


    ];
    const publicationsData = ref({});
    const perPage = ref(10)
    const totalPublicationss = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const statusFilter = ref(null)
    const catFilter = ref(null);
    const dataMeta = computed(() => {
        const localItemsCount = refPublicationsListTable.value ? refPublicationsListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalPublicationss.value,
        }
    })
   
    const refetchData = () => {
        refPublicationsListTable.value.refresh()
    }
    watch([currentPage, perPage, searchQuery, statusFilter,catFilter], () => {
        refetchData()
    })
    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);
        console.log('offset',offset);
        store
          .dispatch('app-publications/fetchData', {
            limit: perPage.value,
            offset:offset,
            keywords: searchQuery.value,
              
            category_id:catFilter.value
            
              /* page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            status: statusFilter.value,*/
          })
          .then(response => {
           
            const  Publicationss  = response.data.data
             // console.log('Publicationss',Publicationss);
            const total = response.data.total;
            callback(Publicationss)
            totalPublicationss.value = total
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error fetching invoices' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }
    const updatePublications = (data)=>{

      publicationsData.value = data;
      isPublicationsFormSidebarActive.value = true;
    }
    const deleteData = (id) => {
        //fetchDeleteProperty
        store.dispatch('app-publications/deletePublications',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete User",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
        //console.log('id', id);
        
      }
    const resolvePublicationsStatusVariant = status => {
       
        if (status) return 'success'
        if (!status) return 'secondary'
        return 'primary'
    }
    const resolvePublicationsStatusnameVariant = status => {
        console.log('status',status);
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }
    return {
        isPublicationsFormSidebarActive,
        fetchData,
        tableColumns,
        perPage,
        currentPage,
        totalPublicationss,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refPublicationsListTable,
    
        statusFilter,
        catFilter,
        deleteData,

        publicationsData,
        catFilter,
        catsData,
        updatePublications,
        refetchData,
        resolvePublicationsStatusVariant,
        resolvePublicationsStatusnameVariant
    }
}